(() => {
  const config = document.currentScript?.dataset;
  if (!config?.frattoliLabel || !config?.frattoliLogo) return;
  const mobile = window.matchMedia('(max-width: 767px)');
  const heroActions = document.querySelector('main .hero-actions');
  const runtimeRoots = new Set();
  const syncVisibility = (root) => {
    const button = root.querySelector('button[part="activator"]');
    if (!button) return;
    const hide = !document.querySelector('shopify-chat')?.hasAttribute('data-frattoli-chat-ready') || (mobile.matches && heroActions && heroActions.getBoundingClientRect().bottom > 0);
    button.style.setProperty('visibility', hide ? 'hidden' : 'visible', 'important');
  };
  let scheduled = false;
  const refreshVisibility = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      runtimeRoots.forEach(syncVisibility);
    });
  };
  if (heroActions) {
    window.addEventListener('scroll', refreshVisibility, {passive: true});
    window.addEventListener('resize', refreshVisibility, {passive: true});
    window.addEventListener('pageshow', refreshVisibility);
    mobile.addEventListener('change', refreshVisibility);
    new ResizeObserver(refreshVisibility).observe(heroActions);
  }
  const seenShells = new WeakSet();
  const seenRuntimes = new WeakSet();
  const brand = (root) => {
    const button = root.querySelector('button[part="activator"]');
    if (!button) return;
    const label = button.querySelector('.activator__label');
    const icon = button.querySelector('.activator__icon');
    if (!label || !icon) return;
    syncVisibility(root);
    button.style.setProperty('background', '#102b1c', 'important');
    button.style.setProperty('color', '#fffdf8', 'important');
    icon.style.cssText = 'display:grid;place-items:center;width:24px;height:24px;min-width:24px;min-height:24px;flex:0 0 24px;overflow:visible;';
    if (label.textContent !== config.frattoliLabel) label.textContent = config.frattoliLabel;
    if (button.getAttribute('aria-label') !== config.frattoliOpen) button.setAttribute('aria-label', config.frattoliOpen);
    if (!icon.querySelector('img[data-frattoli-chat-logo]')) {
      const image = document.createElement('img');
      image.dataset.frattoliChatLogo = '';
      image.src = config.frattoliLogo;
      image.alt = '';
      const reveal = () => { document.querySelector('shopify-chat')?.setAttribute('data-frattoli-chat-ready', ''); refreshVisibility(); };
      image.addEventListener('load', reveal, {once: true});
      image.addEventListener('error', reveal, {once: true});
      image.width = 24;
      image.height = 24;
      image.style.cssText = 'display:block;width:24px!important;height:24px!important;min-width:24px;min-height:24px;max-width:none;flex:none;aspect-ratio:1;object-fit:cover;border-radius:50%;';
      icon.replaceChildren(image);
      if (image.complete) reveal();
    }
  };
  const attachRuntime = (runtime, attempts = 0) => {
    if (!runtime || seenRuntimes.has(runtime)) return;
    if (!runtime.shadowRoot) {
      if (attempts < 60) window.setTimeout(() => attachRuntime(runtime, attempts + 1), 250);
      return;
    }
    seenRuntimes.add(runtime);
    const root = runtime.shadowRoot;
    runtimeRoots.add(root);
    new MutationObserver(() => brand(root)).observe(root, {childList: true, subtree: true});
    brand(root);
  };
  const attachShell = (shell, attempts = 0) => {
    if (!shell || seenShells.has(shell)) return;
    if (!shell.shadowRoot) {
      if (attempts < 60) window.setTimeout(() => attachShell(shell, attempts + 1), 250);
      return;
    }
    seenShells.add(shell);
    const root = shell.shadowRoot;
    const findRuntime = () => attachRuntime(root.querySelector('shopify-agent-runtime'));
    new MutationObserver(findRuntime).observe(root, {childList: true, subtree: true});
    customElements.whenDefined('shopify-agent-runtime').then(findRuntime);
    findRuntime();
  };
  const locate = () => {
    const shell = document.querySelector('shopify-chat');
    if (!shell) return;
    attachShell(shell);
    observer.disconnect();
  };
  const observer = new MutationObserver(locate);
  observer.observe(document.documentElement, {childList: true, subtree: true});
  customElements.whenDefined('shopify-chat').then(locate);
  locate();
  window.setTimeout(() => observer.disconnect(), 30000);
})();

